"use strict";

import { c as _c } from "react/compiler-runtime";
import { useDEPortalAsideItems } from '@autoguru/aside-items';
import { MFE_BASE_PATH } from '@autoguru/global-configs';
import { ExpandSideNav } from '@autoguru/expand-side-nav';
import { jsx as _jsx } from "react/jsx-runtime";
export const pageAsidePortalId = '__ag-aside__';
export const AppAside = () => {
  const $ = _c(4);
  if ($[0] !== "fde41ff92b179f1b9957897328f3acfbe1c696f611e84e08e587369294fd20f6") {
    for (let $i = 0; $i < 4; $i += 1) {
      $[$i] = Symbol.for("react.memo_cache_sentinel");
    }
    $[0] = "fde41ff92b179f1b9957897328f3acfbe1c696f611e84e08e587369294fd20f6";
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      baseUrl: MFE_BASE_PATH
    };
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const asideItems = useDEPortalAsideItems(t0);
  let t1;
  if ($[2] !== asideItems) {
    t1 = /*#__PURE__*/_jsx(ExpandSideNav, {
      includeAuth: true,
      logoutRedirect: MFE_BASE_PATH,
      asideItems: asideItems
    });
    $[2] = asideItems;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};